import React, { useState } from 'react'
import { Card, Col, Row, Container, Button, Table, Form } from 'react-bootstrap';
import Sidebar from './Sidebar';
import { getPagesByLang, deletePage, getMainConfig, updateMainConfig } from './apiCalls';
import { Link, useNavigate } from 'react-router-dom';

export default function ObservatoryPages() {
  const navigate = useNavigate();

  const [activateObservatory, setActivateObservatory] = useState(true);
  const [mainConfig, setMainConfig] = useState({});
  const [pagesList, setPagesList] = useState([]);

  const refreshList = () => {
    getPagesByLang( 'es', (response) => {
      setPagesList(JSON.parse(response));
    });

    getMainConfig(setMainConfig);
  }  

  React.useEffect(
    refreshList,
  []);

  const handleDeletePage = (id) => {

    deletePage(id)
      .then(() => {
        getPagesByLang( 'es', (response) => {
          setPagesList(JSON.parse(response));
        });
    })
    
  }

  const updateEnableObservatory = () => {
    if (
      mainConfig?.enabledDA &&
      typeof mainConfig.enabledDA !== 'string' &&
      !(mainConfig.enabledDA instanceof String)
    ) {
      mainConfig.enabledDA = JSON.stringify(mainConfig.enabledDA);
    }
    mainConfig?.enabledObservatory && updateMainConfig(mainConfig);
  }

  return (
    <Container fluid>
      <Row>
          <Col xs={2} >
            <Sidebar />
          </Col>
          <Col xs={10} className="admin-content">
            <Card>
              <Card.Header> Visibilidad </Card.Header>
              <Card.Body>
                <Form>
                  <Form.Group className={""}>
                      <Form.Check
                        id= { 1 }
                        type = 'switch'
                        label={ 'Habilitar Observatorio' }
                        //value={ mainConfig && mainConfig.enabledObservatory === }
                        defaultChecked = {mainConfig && mainConfig.enabledObservatory === 'true'}
                        checked = {mainConfig && mainConfig.enabledObservatory === 'true'}
                        onChange={ (e) => {
                          //setActivateObservatory(!activateObservatory)
                          setMainConfig({
                            ...mainConfig,
                            enabledObservatory: JSON.stringify(e.target.checked)
                          });
                        }}
                      />
                  </Form.Group>
                  <br />
                  <Button _type="submit" className="admin-add-item-button" onClick={() => {updateEnableObservatory()}}>Guardar</Button>
                </Form>
              </Card.Body>
            </Card>
            <Card>
              <Card.Header> Páginas de Observatorio </Card.Header>
              <Card.Body>
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Nombre</th>
                      <th>Fecha de creación</th>
                      <th>Acciones</th>			
                    </tr>
                  </thead>
                  <tbody>
                    {
                      pagesList && pagesList.map((item, itemId) => {
                        return (
                          <tr>
                            <td>{/*itemId + 1*/ itemId }</td>
                            <td>
                              { item.title }
                            </td>
                            <td>
                              { item.created_at }
                            </td>
                            <td><Button _type="submit" className="admin-add-item-button" onClick={() => {navigate(`/admin/observatory-pages/edit/${item.code}`);}}>Editar</Button> | <Button _type="submit" className="admin-delete-item-button" onClick={() => {handleDeletePage(item.code)}}>Eliminar</Button> </td>
                          </tr>
                        )
                      })
                    }
                  </tbody>
                </Table>
              </Card.Body>
            </Card>
            <Button _type="submit" className="odisea-form-button-submit" onClick={() => {navigate('/admin/observatory-pages/add');}}>Agregar Página</Button>
          </Col> 
      </Row>
    </Container>
  )
}
